import { useT } from '../i18n';
import { useUpdateAvailable } from '../pwa';
import { MenuIcon } from './MenuIcon';

/** "New version available" bar, bottom of the screen; shown when a new service worker waits. */
export function UpdatePrompt() {
  const t = useT();
  const { available, apply, dismiss } = useUpdateAvailable();
  if (!available) return null;
  return (
    <div className="nv-toasts nv-toasts-bottom" role="status" aria-live="polite">
      <div className="nv-toast">
        <div className="nv-toast-body">
          <p className="nv-toast-title">{t('pwaUpdateAvailable')}</p>
          <button type="button" className="nv-btn2" onClick={apply}>
            <MenuIcon name="refresh" />
            {t('pwaUpdateReload')}
          </button>
        </div>
        <button
          type="button"
          className="nv-toast-close"
          aria-label={t('runNotifyDismiss')}
          onClick={dismiss}
        >
          <MenuIcon name="close" />
        </button>
      </div>
    </div>
  );
}
